// it has to be called messages...https://github.com/kazupon/vue-i18n/issues/244
const en = {
  message: {
    choose_date_time: "Choose date and time",
    choose_tickets: "Choose Your Tickets | Choose your ticket | Choose your {count} tickets",
    ticket_delivery: "Ticket delivery address",
    empty_basket: "Your shopping cart is empty",
    shopping_cart: "Shopping cart",
    choose_seating_area: "Choose your seating area",
    newsletter_signup:
      "I prefer not to receive WestK Newsletter as described below, including but not limited to the latest updates on membership benefits, shop/merchandise promotions, and event invitations.​<br><br>We intend to use your personal details provided or providing you with information about activities and events organised by or taking place at the West Kowloon Cultural District. Please tick the box above if you agree to such use. You can unsubscribe at anytime or access or correct your personal details at anytime in accordance with the <a href='https://www.westk.hk/en/privacy#pics' target='_blank'>PICS.</a>",
    choose_seats: "Choose your seats in the {sectionAlias}",
    budget_per_ticket: "Ticket price",
    ticket_quantity_header: "Ticket quantity",
    ticket_quantity_body: "How many tickets would you like?",
    best_available_body: "The two sets of seats we recommend for you are highlighted in blue. Please choose one and click on CONFIRM SEATS to continue.",
    hot_show_body: "The seats we recommend for you are highlighted in yellow. Please click on CONFIRM SEATS to continue.",
    calendar_prompt: "Which date and time would you like?",
    calendar_instruction: "You may choose from the dates highlighted.",
    confirmation_screen: "Order Confirmed",
    register_success: "Thank you for your registration",
    register_confirmation_email: "A confirmation email will be sent to your registered mailbox soon.",
    booking_reference: "Transaction No.",
    privacy_policy:
      "By clicking Submit, I confirm that I have read in detail and fully understood and agree to be bound by the <a href='https://www.westk.hk/en/termsandconditions' target='_blank'>Terms and Conditions</a> and consent to the use of the personal data provided on this form in accordance with the <a href='https://www.westk.hk/en/privacy' target='_blank'>Privacy Policy</a>.",
    download_eticket: "Download your e-ticket",
    payment_method: "Payment method",
    booking_date: "Date of Purchase",
    help: "Help",
  },
  payment: {
    payment_details: "How would you like to pay?",
    payment_failed: "Payment Failed",
    payment_failed_explanation: "Transaction failed. We are unable to process your payment. Please try again.",
    order_confirmation: "Your Order is Confirmed! Thank you for your booking. A confirmation email has been sent to {email}",
    order_summary: "Order summary",
    subtotal: "Subtotal",
    delivery_cost: "Delivery fees",
    total: "Total",
    donate_link: "Support Us",
    customer_portal: "Please check ‘My Event’ to review your purchase order.",
    pdf_link: "Download your e-ticket",
    continue_shopping: "Continue Shopping",
    quantity: "Qty",
    unit_price: "Unit price",
    booking_fee: "Booking fees",
    ticket_details: "Ticket details",
    no_cost: "The items in your cart do not cost anything. Click continue to complete your order.",
  },
  payment_methods: {
    JCB_WKCD_ONLINE: "JCB",
    CUP_WKCD_ONLINE: "UnionPay Card Online Payment",
    AMEX_WKCD_ONLINE: "American Express",
    VISA_WKCD_ONLINE: "Visa",
    MASTER_WKCD_ONLINE: "Mastercard",
  },
  newsletter: {
    button: "Sign Up",
    placeholder: "Your Email Address",
  },
  announcement: {
    title: "ANNOUNCEMENT",
    null_str: "There are no announcements",
    view_all: "View All",
  },
  availability: {
    sold_out: "Sold Out",
    available: "Available",
    limited_seats: "Limited Seats",
    single_seat: "Single Seat",
  },
  event: {
    status: {
      available: "Tickets",
      limited: "Limited availability",
      sold_out: "Sold out",
      cancelled: "Show cancelled",
      postponed: "Show postponed",
      coming_soon: "Coming soon",
      temporarily_off_sale: "Temporarily off sale",
    },
  },
  session: {
    status: {
      coming_soon: "Coming soon",
      registration_closed: "Registration closed",
      full: "Full",
      full_extended: "This event is currently full and registration has been closed.",
      temporarily_unavailable: "Temporary unavailable",
    },
  },
  register: {
    register_title: "Registration Form",
    register_description: "Have a MyWestK account? Sign in for faster registration.",
    newsletter:
      "I prefer not to receive WestK Newsletter as described below, including but not limited to the latest updates on membership benefits, shop/merchandise promotions, and event invitations.​<br><br>The Group intends to use and share (within the Group and with selected Partners) your personal data for sending Marketing Communications relating to products, activities, events and services, according to the <a href='https://www.westk.hk/en/about-us/privacy' target='_blank'>Privacy Policy</a>.",
    submit: "Submit",
    select_session_title: "Select Date and Time",
    not_this_user: "Not {name}?",
    registration_complete: "Continue to What's On",
    registration_sign_up_prompt: " Create account",
    help_text: "required field",
  },
  ticket: {
    add_ticket: "Add 1 ticket",
    remove_ticket: "Remove 1 ticket",
    discount_code: "Please fill out the promo code.",
    quantity: "Quantity",
    price: "Price",
    type: "Ticket Type",
    failed_to_add_to_cart: "Failed to add to cart",
    successfully_added_to_cart: "Successfully added to cart",
  },
  timer: {
    timer_text_1: "Seats reserved for ",
    timer_text_2: " minutes",
  },
  buttons: {
    seat_area_and_tickets: "Next",
    view_calendar: "View calendar",
    add_to_basket: "Add to Cart",
    payment_method: "Next",
    return_to_website: "Return to website",
    checkout: "Checkout",
    save_basket_and_continue: "Continue shopping",
    ok_continue: "OK",
    go_back: "Go back",
    close: "Close",
    choose_seats: "Next",
    confirm_seats: "Next",
    ok_got_it: "OK",
    hide_calendar: "Hide calendar",
    zoom_in: "Zoom in",
    zoom_out: "Zoom out",
    zoom_reset: "Reset",
    add_link_text: "Buy More",
    ok: "OK",
    back: "Back",
  },
  footer: {
    copyright: "WestK and WestK logos are trademarks of West Kowloon Cultural District Authority.",
    copyright_2: " West Kowloon Cultural District Authority. All Rights Reserved.",
    links: {
      privacy: "Privacy",
      ts_and_cs: "Terms and conditions",
      freedom_of_information: "Freedom of information",
      contact: "Contact",
      join_in: "Join in",
    },
  },
  modal: {
    cart_timer_warning: "You only have 5 minutes remaining!",
    cart_timer_body: "Your cart will be automatically cleared in 5 minutes, ensure you have completed your order by then, to avoid our tickets being released.",
    ticket_advisory_title: "Notice",
    choose_area: {
      availability: "Seat Availability",
      category: "Ticket Price",
      section: "Section",
    },
    accessible_zone: {
      title: "Accessible Zone",
      message:
        "You have selected seat(s) at the accessible zone. The seats in this zone are reserved for the exclusive use of wheelchair users and their companions. We reserve the rights to reject admission or relocate the seats for ineligible users. By accepting, you are confirming that you understand this and the ticket(s) is/are intended for wheelchair user(s) and their companion(s).",
    },
    members_only: {
      title: "You have selected member tickets",
      no_valid_membership: "The selected ticket type is only available in specific membership. Please select other ticket type.",
      quota_reached: "You have used up the quota of your selected ticket type. Please change the quantity or select other ticket types.",
      connection_issue: "An error occurred during connecting to the membership system. Please try again later.",
      further_information: "Find out more",
      select_non_member_tickets: "Select non-member tickets",
    },
    hkid_warning_header: "Please make sure you have a valid HKID to receive concessionary prices",
    hkid_warning_body: "Our staff will require you to show your HKID on entry. Your HKID must be valid in order to receive the concessionary price.",
    delete_confirm_title: "Are you sure you want to delete this item?",
    delete_confirm_text: "Once you have confirmed you’d like to proceed with deleting this item, it might not be available again.",
  },
  account: {
    overview: "Overview",
    events: "My Events",
    profile: "My Profile",
    logout: "Logout",
    hello: "Hello",
    sign_in: "Login",
    new_customer: "New customer?",
    start_here: "Start here",
    your_account: "Your account",
    login: "Login",
    shoppingCart: "Shopping Cart",
    myEvent: "My Event",
  },
  errors: {
    select_all_tickets: "Ticket quantity must match seat choice. Please select {count} tickets",
    max_allowed_tickets: "The maximum allowance for this ticket type ({count}) has been exceeded.",
    invalid_discount_code_format: "Please enter a valid promo code.",
    fix_errors: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    no_seating_area_selected: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    seating_area_failed: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    retrieve_seat_options: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    date_times_retrieval_failed: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    ticket_type_retrieval_failed: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    delivery_method_retrieval_failed: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    shopping_cart_items_retrieval_failed: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    shopping_cart_submission_failed: "Unexpected system error. Please try again later. (Add to Cart Failed)",
    select_a_set: "Please select a set of seats.",
    too_many_tickets: "You are only allowed to choose up to 40 seats.",
    reserve_tickets_failed: "Unexpected system error. Please try again later. (Failed to reserve seat)",
    required_field: "* Required Field",
    some_tickets_werent_added: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    cart_confirmation: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    seat_offers_failed_other: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    ticket_type_available_quantity: "Selected quantity does not match with configured allowed quantity.",
    registration_submission_failed: "Unable to complete registration. Please try again later.",
    registration_generic_error: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    generic_error: "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
    invalid_email: "Please enter a valid email address.",
    crm: {
      sip: {
        error: {
          "401001": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "401002": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "401003": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "404001": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "405001": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "500100": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "400001": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "400500": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "500001": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "500200": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "500201": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "410001": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
          "400701": "We’re sorry there was an issue processing your ticket purchase. Please try again later or call our ticketing hotline (852)2200 0022 if the problem persists.",
        },
        "no-vacancy": "This event does not have sufficient vacancy for you to register.",
      },
    },
    sistic: {
      error: {
        cart: {
          "add-event": {
            "mix-not-allowed": "Please complete purchase of existing shopping cart items before proceeding to purchase tickets for current event.",
          },
          "add-to-cart": {
            fail: "Unexpected system error. Please try again later. (Add to Cart Failed)",
            product: {
              "no-config": "Unexpected system error. Please try again later. (No configuration)",
            },
            "quota-reached": "Unexpected system error. Please try again later. (Exceed event allowed ticket max number)",
          },
          barcode: {
            retrieval: {
              fail: "Unexpected system error. Please try again later. (Barcode definition and barcode fields)",
            },
          },
          "exceed-allocation": "Unexpected system error. Please try again later. (Exceeded allocation for cart)",
          inventory: {
            check: {
              fail: "Unexpected system error. Please try again later. (Error when evaluating inventories)",
            },
            duplicates: "Unexpected system error. Please try again later. (Duplicates found in cart)",
            empty: "Unexpected system error. Please try again later. (Inventory list is empty)",
            "groupbooking-ga": {
              "not-found": "",
            },
            "quantity-price-class": {
              mismatch: "Unexpected system error. Please try again later. (Inventory and price class map quantities do not tally)",
            },
          },
          "new-event": {
            "mix-not-allowed": "Please complete purchase of existing shopping cart items before proceeding to purchase tickets for current event.",
          },
          "not-found": "Unexpected system error. Please try again later. (Cart not found)",
          order: {
            "cart-total-amount": {
              mismatch: "Unexpected system error. Please try again later. (Cart Item total amount mismatch)",
            },
            "delivery-charge": {
              mismatch: "Unexpected system error. Please try again later. (Delivery charge not matched)",
            },
            generic: "Unexpected system error. Please try again later. (Failed to process your order)",
            "not-found-expired": "Unexpected system error. Please try again later. (Order reference no. not found or expired)",
            "paid-amount": {
              mismatch: "Unexpected system error. Please try again later. (Order reference no. paid amount mismatch)",
            },
            "product-total-amount": {
              mismatch: "Unexpected system error. Please try again later. (Product total amount mismatch)",
            },
            seat: {
              "not-available": "Unexpected system error. Please try again later. (Seats not available)",
              reserve: {
                fail: "Unexpected system error. Please try again later. (Failed to reserve seat)",
              },
            },
          },
          postcommit: {
            "calculated-precommit-amount": {
              mismatch: "Unexpected system error. Please try again later. (Total amount not matching)",
            },
            "exceed-max-qty": "Exceeded max quantity for ticket type.",
            "exceed-quota": "Exceeded quantity of shopping cart.",
            fail: "Unexpected system error. Please try again later. (Failed to confirm order)",
            inventory: {
              unavailable: "Unexpected system error. Please try again later. (Seats may have been released)",
            },
          },
          precommit: {
            "creditcard-delivery-method": {
              invalid: "The credit card is not applicable for the delivery method.",
            },
            "creditcard-price-class": {
              invalid: "The credit card is not applicable for the ticket type.",
            },
            "delivery-method": {
              invalid: "Unexpected system error. Please try again later. (Invalid delivery method)",
              "no-fee-config": "Unexpected system error. Please try again later. (No fee configuration for delivery base)",
            },
            "mailing-address": {
              invalid: "Unexpected system error. Please try again later. (Invalid mailing country/region)",
            },
            "payment-method": {
              creditcard: {
                invalid: "The credit card is not applicable for the payment method.",
              },
              invalid: "Unable to complete transaction. Please try a different payment method.",
            },
            "product-offsales": "Unexpected system error. Please try again later. (Temporarily off sales)",
          },
          promo: {
            code: {
              "hold-code": {
                "no-config": "Invalid promo code.",
              },
              invalid: "Invalid promo code.",
              popup: {
                text: "Invalid promo code.",
              },
              "price-class": {
                mismatch: "Unexpected system error. Please try again later. (Not tied with promo code)",
              },
            },
            password: {
              empty: "Promo password is required.",
              inactive: "Unexpected system error. Please try again later. (Promo password is not active)",
              incorrect: "Promo password is incorrect.",
              invalid: "Promo password is invalid.",
              "quota-reached": "Promo password exceeds the usage limit.",
            },
          },
          "qty-config": {
            qty: {
              mismatch: "Selected quantity does not match with configured allowed quantity.",
            },
          },
          "sales-quota": {
            transaction: {
              exceeded: "Your order could not be processed. The item you selected has sold out,please select another ticket type. We apologise for any inconvenience caused.",
            },
          },
          "top-status": {
            payment: {
              fail: {
                firstdata: "Transaction failed. We are unable to process your payment. Please try again.",
              },
            },
          },
        },
        product: {
          "detail-seatmap": {
            generation: {
              coordinate: {
                missing: "Unexpected system error. Please try again later. (Seatmap properties - coordinates)",
              },
              fail: "Unexpected system error. Please try again later. (Detail seatmap error)",
              seatangle: {
                missing: "Unexpected system error. Please try again later. (Seatmap properties - seat angles)",
              },
            },
            insufficient: "There aren't enough available seats in this section. Please select fewer seats, or try another section.",
          },
          icc: {
            invalid:
              "Sorry, the event has been expired. Check out our <a href='https://www.westk.hk/en/whats-on/' target='_blank'>What’s On</a> section, stay up to date with the latest events in West Kowloon.",
            "not-found":
              "Sorry, the event has been expired. Check out our <a href='https://www.westk.hk/en/whats-on/' target='_blank'>What’s On</a> section, stay up to date with the latest events in West Kowloon.",
          },
          "no-common-delivery": "Unexpected system error. Please try again later. (No Common delivery method found)",
          "no-common-delivery-payment": "Unexpected system error. Please try again later. (No common delivery method and payment method found)",
          "no-common-payment": "Unexpected system error. Please try again later. (No common payment method found)",
          "overview-seatmap": {
            generation: {
              fail: "Unexpected system error. Please try again later. (Generating overview seatmap)",
            },
          },
          param: {
            icc: {
              missing: "Unexpected system error. Please try again later. (Missing Internet Content Code)",
            },
            mode: {
              missing: "Unexpected system error. Please try again later. (Missing Event mode)",
            },
            "price-cat-id": {
              missing: "Unexpected system error. Please try again later. (Missing Price Category ID)",
            },
            "product-id": {
              missing: "Unexpected system error. Please try again later. (Missing Product ID)",
            },
            quantity: {
              missing: "Unexpected system error. Please try again later. (Missing quantity)",
            },
            "seat-section-id": {
              missing: "Unexpected system error. Please try again later. (Missing Seat Section ID)",
            },
          },
          seats: {
            release: "Unexpected system error. Please try again later. (Error releasing seats)",
            reserve: "Unexpected system error. Please try again later. (Error reserving seats)",
          },
          "updated-event": {
            "not-found": "Unexpected system error. Please try again later. (No updated event found)",
          },
        },
      },
    },
  },
  language: {
    selected: "Select a language. The current language is English",
  },
  delivery_details: {
    delivery_address_1: "Address Line 1",
    delivery_address_2: "Address Line 2",
    delivery_address_3: "Address Line 3",
    postcode: "Postcode",
    select_a_country: "Please select a country / region",
  },
  delivery_warning: {
    hong_kong_only: "Hong Kong SAR",
    macau_only: "Macau SAR",
  },
  delivery_methods: {
    KIOSK_OFFICE_PICKUP_WKCD: {
      title: "Collect at Venue Ticket Office or Self-service Kiosk in person",
      description:
        "Collect your ticket(s) at the venue ticket office or self-service kiosk. You must provide the credit card used for payment, booking transaction number and email address for ID verification. Please refer to individual event requirements.",
    },
    COURIER_HK: {
      title: "Local Courier",
      description: "A door-to-door service requiring a signature of receiver on delivery.",
    },
    COURIER_MC: {
      title: "Courier (Macau)",
      description: "A door-to-door service requiring a signature of receiver on delivery.",
    },
    COURIER_ML1: {
      title: "Courier (Mainland China)",
      description: "A door-to-door service requiring a signature of receiver on delivery.",
    },
    COURIER_OS1: {
      title: "Courier (Overseas)",
      description: "A door-to-door service (excluding Hong Kong, Macau and Mainland China) requiring a signature of receiver on delivery.",
    },
    E_TICKET: {
      title: "E-Ticket",
      description: "Download and print your e-ticket by clicking the link in your confirmation email",
    },
    REGISTERED_MAIL_HK: {
      title: "Local Registered Mail",
      description: "A signature of receiver is required on delivery.",
    },
    REGISTERED_MAIL_OS: {
      title: "Registered Mail (Overseas)",
      description: "A signature of receiver is required on delivery.",
    },
    BLANK_DELIVERY_OPTION: {
      title: "Select a delivery option",
    },
  },
  seats_legend: {
    available: "Available",
    unavailable: "Unavailable",
    selected: "Selected",
    offered: "Offered",
  },
  seating_selection_info: {
    your_selection: "Your selection",
    row: "Row",
    seat: "Seat",
    selected: "selected",
  },
  search: {
    placeholder: "Type to search...",
    cta: "Search",
  },
  header: {
    logged_in: {
      text: "Your items in the shopping cart will be removed after you log out.",
    },
  },
};

export default en;
